import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '10px 0',
    gap: 10,
    fontSize: 12,
  },

  filterWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },

  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    justifyContent: 'flex-start',
  },

  filtersTasks: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 0',
    position: 'relative',
    backgroundColor: '#efefef',
    borderRadius: 8,
    padding: 10,

    '& > div': {
      display: 'flex',
      alignItems: 'center',

      '& > div': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 60,

        '& > span': {
          marginRight: 20,
        },
      },
    },
  },

  datePickerFilter: {
    margin: 0,
    backgroundColor: Colors.white,
    '& input': {
      fontSize: 12,
    },
  },

  filterButton: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',

    '& > span': {
      marginRight: 20,
    },
  },

  filterIcon: {
    cursor: 'pointer',
    fontSize: 30,
  },

  paperOverwrite: {
    overflow: 'visible',
    overflowX: 'visible',
    overflowY: 'visible',
  },

  filtersModal: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    backgroundColor: Colors.white,
    borderRadius: 8,
    padding: 12,
    fontSize: 12,

    '& h3': {
      fontSize: 14,
    },
  },

  select: {
    fontSize: '1.25rem',
  },
  menuItem: {
    fontSize: '1.25rem',
  },

  filterRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}))

export default styles
